(function () {
    'use strict';

    angular.module('core')
        .service('DataService', function ($q, $rootScope, $http, $filter, serviceBase, dataConfigService, dialogService) {
            var _data = [],
                _regions = [],
                _roadServices = [],
                _masteries = [],
                _violations = [],
                _notesTypes = [],
                _status = [],
                _workTypes = [],
                _currentObj = {},
                _descriptionTexts = {};

            var __regionsIdValueMapper = [],
                __roadServicesIdValueMapper = [],
                __masteriesIdValueMapper = [],
                __violationsIdValueMapper = [];

            function formMultichoiceFields() {
                if (_data
                    && _regions && _regions.length > 0
                    && _roadServices && _roadServices.length > 0
                    && _masteries && _masteries.length > 0
                    && _violations && _violations.length > 0) {
                    angular.forEach(_data, function (item) {
                        item.regionuPavadinimai = '';
                        item.tarnybuPavadinimai = '';
                        item.meistrijuPavadinimai = '';
                        item.defektuGrupiuPavadinimai = '';

                        item.defektuGrupiuPavadinimai = item.pazeidimai
                            .map(function (violationId) { return __violationsIdValueMapper[violationId]; })
                            .join(', ');
                        item.regionuPavadinimai = item.regionai
                            .map(function (regionId) { return __regionsIdValueMapper[regionId]; })
                            .join(', ');
                        item.tarnybuPavadinimai = item.tarnybos
                            .map(function (roadServiceId) { return __roadServicesIdValueMapper[roadServiceId]; })
                            .join(', ');
                        item.meistrijuPavadinimai = item.meistrijos
                            .map(function (masteryId) { return __masteriesIdValueMapper[masteryId]; })
                            .join(', ');
                    });
                }
            }

            function resetClassifiers() {
                _regions = [];
                _roadServices = [];
                _masteries = [];
                _violations = [];
                _notesTypes = [];
                _status = [];
                _workTypes = [];
                _currentObj = {};
                _descriptionTexts = [];

                __regionsIdValueMapper = [];
                __roadServicesIdValueMapper = [];
                __masteriesIdValueMapper = [];
                __violationsIdValueMapper = [];
            }

            function formFilterInValue(filters) {
                if (filters.length !== 0) {
                    angular.forEach(filters, function(filter) {
                        if (filter.operand === 'IN') {
                            if (!filter.valuesArray || !filter.valuesArray.length) {
                                filter.value = '()';
                                return;
                            }
                            filter.value = '(';
                            for (var i = 0; i < filter.valuesArray.length; i++) {
                                filter.value += filter.valuesArray[i];
                                if (i < filter.valuesArray.length - 1) {
                                    filter.value += ', ';
                                }
                            }
                            filter.value += ')';
                        }
                    });
                }
            }

            function undToEmpty(str) {
                if (angular.isUndefined(str) || str == null) {
                    return '';
                }
                return str;
            }
            return {
                getData: function () {
                    if (_data) {
                        return _data;
                    }
                },
                refreshData: function (filters) {
                    var filtersCopy = angular.copy(filters);
                    formFilterInValue(filtersCopy);
                    $http.post(serviceBase + '/road-monitoring/filter', filtersCopy).
                        success(function (data) {
                            if (data.error) {
                                _data = [];
                                alert('Dėmesio: jūsų nurodyti filtravimo kriterijai atrinko ' + data.objectsCount +
                                    ' rezultatų, kai maksimalus galimas kiekis yra ' + data.availableRecsCount +
                                    '. Prašome susiaurinti paiešką patikslinus filtro parametrus.');
                            } else {
                                _data = data.data;
                                formMultichoiceFields();
                                $rootScope.$emit('reloadTable');
                            }
                        }).
                        error(function () {
                            _data = [];
                        });
                },
                getNotesType: function () {
                    return _notesTypes;
                },
                getRegions: function () {
                    return _regions;
                },
                getRoadServices: function () {
                    return _roadServices;
                },
                getMasteries: function () {
                    return _masteries;
                },
                getViolations: function () {
                    return _violations;
                },
                getStatus: function () {
                    return _status;
                },
                getWorkTypes: function () {
                    return _workTypes;
                },
                getDescriptionTexts: function () {
                    return _descriptionTexts;
                },
                setCurrentObject: function (obj) {
                    _currentObj = obj;
                },
                getCurrentObject: function () {
                    return _currentObj;
                },
                getResolvedStatusId: function () {
                    var id;
                    for (var i = 0; i < _status.length; i++) {
                        var element = _status[i];
                        if (element.meaning === 'Išspręstas') {
                            id = element.id;
                            break;
                        }
                    }
                    return id;
                },
                isIE: function () {
                    var myNav = navigator.userAgent.toLowerCase();
                    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
                },
                filterData: function (element, filterString) {
                    if (!filterString || !filterString.length) {
                        return true;
                    }
                    var str = filterString.toLowerCase();
                    return ('idx' + element.id) == str || element.kelioNumeris.toLowerCase().indexOf(str) != -1 ||
                        element.kelioPavadinimas.toLowerCase().indexOf(str) != -1 ||
                        ('' + element.kmNuo).toLowerCase().indexOf(str) != -1 ||
                        ('' + element.kmIki).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.adresas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.regionuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.tarnybuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.meistrijuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.defektuGrupiuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.defektoStatusas.meaning).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty($filter('date')(element.apziurosData)).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty($filter('date')(element.sprendimoData)).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.sukuresNaudotojas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.aprasymas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.darbuRusis).toLowerCase().indexOf(str) != -1;
                },
                filterSelected: function (el) {
                    return el.selectedRec;
                },
                getCSV: function (filterString) {
                    var arrData = typeof _data != 'object' ? JSON.parse(_data) : _data;
                    var self = this;
                    arrData = $filter('filter')(arrData, function (element) { return self.filterData(element, filterString); });
                    var selectedRecsArray = $filter('filter')(arrData, function (el) { return self.filterSelected(el) });
                    if (selectedRecsArray.length > 0) {
                        arrData = selectedRecsArray;
                    }
                    var CSV = '';
                    var row = '';
                    var skip = [];
                    for (var index in arrData[0]) {
                        for (var i = 0; i < dataConfigService.config.length; i++) {
                            if (dataConfigService.config[i].variable === index) {
                                row += dataConfigService.config[i].parameterName + ';';
                                break;
                            }
                            if (i === dataConfigService.config.length - 1) {
                                skip.push(index);
                            }
                        }
                    }
                    row = row.slice(0, -1);
                    CSV += row + '\r\n';

                    for (var i = 0; i < arrData.length; i++) {
                        var row = '';
                        for (var index in arrData[i]) {
                            if (skip.indexOf(index) !== -1)
                                continue;
                            if (
                                arrData[i][index] !== null
                                && (index === 'apziurosData' || index === 'sprendimoData' || index === 'redagavimoData')
                            ) {
                                var date = new Date(arrData[i][index]);
                                row += '"' + date.getFullYear()
                                    + '.' + this.padNumberWithZero(date.getMonth() + 1)
                                    + '.' + this.padNumberWithZero(date.getDate())
                                    + ' ' + this.padNumberWithZero(date.getHours())
                                    + ':' + this.padNumberWithZero(date.getMinutes())
                                    + ':' + this.padNumberWithZero(date.getSeconds())
                                    + '";';
                            } else {
                                var fieldValue = arrData[i][index];
                                if (typeof fieldValue === 'string') {
                                    fieldValue = fieldValue.replace(/(\r\n|\n|\r)/gm, '');
                                }
                                row += '"' + fieldValue + '";';
                            }
                        }
                        row.slice(0, row.length - 1);
                        CSV += row + '\r\n';
                    }

                    if (CSV == '') {
                        alert('Invalid data');
                        return;
                    }

                    if (typeof Int8Array !== 'undefined') {
                        var orderMark = new Int8Array(3); //adding the UTF-8 byte order mark, so that MS Excel will recognize UTF chars
                        orderMark[0] = 0xEF;
                        orderMark[1] = 0xBB;
                        orderMark[2] = 0xBF;
                    }

                    var fileName = 'KeliuPrieziurosObjektai';
                    var link = document.createElement('a');

                    if (this.isIE() < 10 && navigator.appName == 'Microsoft Internet Explorer') {
                        var ielink = window.open('about:blank', '_blank');
                        ielink.document.write('sep=;\r\n' + CSV);
                        ielink.document.close();
                        ielink.focus();
                        ielink.document.execCommand('SaveAs', true, fileName);
                        ielink.close();
                    }
                    else if (navigator.msSaveBlob) {
                        var blob = new Blob([orderMark, CSV], { type: 'text/csv;' });
                        navigator.msSaveBlob(blob, fileName + '.csv');
                    }
                    else {
                        if (link.download !== undefined) {
                            var blob = new Blob([orderMark, CSV], { type: 'text/csv;' });
                            var url = URL.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute('download', fileName + '.csv');
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }
                },
                loadClassifiers: function () {
                    resetClassifiers();

                    return $q.all([
                        $http.get(serviceBase + '/road-monitoring/resource/notes-type').
                            success(function (data) {
                                _notesTypes = data;
                            }).
                            error(function () {
                                _notesTypes = [];
                            }),

                        $http.get(serviceBase + '/resource/divisions?type=REGION')
                            .success(function (data) {
                                _regions = data;
                                angular.forEach(data, function (value) {
                                    __regionsIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _regions = [];
                            }),
                        $http.get(serviceBase + '/resource/divisions?type=ROAD_SERVICE')
                            .success(function (data) {
                                _roadServices = data;
                                angular.forEach(data, function (value) {
                                    __roadServicesIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _roadServices = [];
                            }),
                        $http.get(serviceBase + '/resource/divisions?type=MASTERY')
                            .success(function (data) {
                                _masteries = data;
                                angular.forEach(data, function (value) {
                                    __masteriesIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _masteries = [];
                            }),


                        $http.get(serviceBase + '/road-monitoring/resource/status').
                            success(function (data) {
                                _status = data;
                            }).
                            error(function () {
                                _status = [];
                            }),

                        $http.get(serviceBase + '/road-monitoring/resource/violations').
                            success(function (data) {
                                _violations = data.map(function (el) {
                                    if (el.aprasymas === 'nenaudojamas') {
                                        el.disabled = true;
                                    }
                                    return el;
                                });
                                angular.forEach(data, function (item) {
                                    __violationsIdValueMapper[item.id] = item.pazeidimas;
                                });
                            }).
                            error(function () {
                                _violations = [];
                            }),

                        $http.get(serviceBase + '/road-monitoring/resource/work-type').
                            success(function (data) {
                                _workTypes = data;
                            }).
                            error(function () {
                                _workTypes = [];
                            }),
                        $http.get(serviceBase + '/road-monitoring/resource/description-texts').
                            success(function (data) {
                                _descriptionTexts = data;
                            }).
                            error(function () {
                                _descriptionTexts = [];
                            })
                    ]);
                },
                downloadFileGet: function (url, fileName) {
                    this.downloadFile(fileName, $http.get(url, { responseType: 'arraybuffer' }))
                },
                downloadFilePost: function(url, fileName, requestData) {
                    this.downloadFile(fileName, $http.post(url, requestData, { responseType: 'arraybuffer' }));
                },
                downloadFile: function (fileName, promise) {
                    function onSuccess(response) {
                        if ('drple' in response.headers()) {
                            var headerValue = response.headers('drple');
                            if (headerValue.includes('zero')) {
                                dialogService.error('Atfiltruotų įrašų sąrašas negali būti tusčias.');
                            } else {
                                var parts = headerValue.split(',');
                                var limit = parts[0].split(':')[1];
                                var currentLength = parts[1].split(':')[1];
                                dialogService.error(
                                    'Per didelis įrašų kiekis. Maksimumas: ' + limit + '. '
                                    + 'Parinkta: ' + currentLength
                                );
                            }
                            return;
                        }

                        var contentType = response.headers('content-type') || 'application/octet-stream';
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            var blob = new Blob([response.data], { type: contentType });
                            var url = urlCreator.createObjectURL(blob);
                            var link = document.createElement('a');
                            link.setAttribute('href', url);
                            link.setAttribute('download', fileName);
                            setTimeout(function () {
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                            });
                        } else {
                            alert('Nepavyko suformuoti atsisiuntimo nuorodos');
                            // eslint-disable-next-line no-console
                            console.error('urlCreator does not exists!');
                        }
                    }

                    function onError(error) {
                        dialogService.error('Nepavyko paruošti failo.');
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }

                    dialogService.reportExportBlockingDialog(promise.then(onSuccess).catch(onError));
                },
                padNumberWithZero: function (number) {
                    return number < 10 ? '0' + number : number;
                }
            };
        });
})();
